import React from 'react'
import { Nav } from '../Components/Nav'
import { Footer } from '../Components/Footer'
import intersect from "../assets/intersect.png"
// import { AiFillRightCircle, AiFillLeftCircle } from "react-icons/ai"
import "./Team.css"


export const Merch = () => {
    // const merch = [
    //     {
    //         id: 1,
    //         src: merch1
    //     },
    //     {
    //         id: 2,
    //         src: merch2
    //     },
    //     {
    //         id: 3,
    //         src: merch3
    //     },
    // ]

    return (
        <>
            <Nav />
            <div className='bg-[#FFFEFE] pt-[90px] text-black font-outfit'>
                <div className='-mt-24'>
                    <img src={intersect} alt="" />
                </div>
                <div className='main-container -mt-16 border-2 mx-40 bg-[rgba(224,224,224,0.3)] backdrop-blur-[15px] mb-16 flex py-12 pl-8 pr-10 rounded-[30px] shadow-xl'>
                    <div className='flex-1 flex justify-center items-center flex-col'>
                        <div className='flex justify-center items-center'>
                            {/* <button>
                                <AiFillLeftCircle style={{ width: "2rem", height: "2rem" }} />
                            </button> */}
                            <img src="https://res.cloudinary.com/desyzom9w/image/upload/v1693996476/evrbr3mrvtb1ayokixsn.png" alt="" className='w-80' />
                            {/* <button>
                                <AiFillRightCircle style={{ width: "2rem", height: "2rem" }} />
                            </button> */}
                        </div>
                        {/* <div className='flex mt-8 gap-4'>
                            {merchandise.map(({ id, src }) => (
                                <div key={id} className='flex border-2 border-gray-300 w-20 items-center'>
                                    <img src={src} alt="" />
                                </div>
                            ))}
                        </div> */}
                    </div>
                    <div className='flex-1'>
                        <div className='mb-8'>
                            <h3 className='text-3xl font-bold font-outfit mb-8'>Roots Merchandise T-Shirt</h3>
                            <p className='text-base'>Get ready to make a statement with our new t-shirt ! Made with high-quality, soft material, this shirt is perfect for any occasion. Whether you're hanging out with friends or running errands, this shirt will keep you comfortable and stylish. Plus, with its eye-catching design, you'll be turning heads wherever you go. Don't miss out on this must-have addition to your wardrobe. Order yours today!</p>
                        </div>
                        <div className='buy-container flex gap-60 items-center'>
                            <div className='flex items-end gap-1 opacity-90'>
                                <div className='text-lg'>Rs</div>
                                <div className='font-extrabold text-3xl'>385</div>
                            </div>
                            <div>
                                <button className='border-2 border-gray-300 px-4 py-2 rounded-full bg-gray-300 hover:bg-black hover:text-white hover:border-black duration-300 hover:shadow-2xl'>Buy Now</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
